import './Knowledge.css';
import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import UserDocumentationImage from '../assets/user.documentation/user.documentation.jpeg';
import ProjectDeliveralblesImage from '../assets/project.deliverables/projectDeliverables.jpg';
import d2_1
    from '../assets/project.deliverables/Levitate D2.1 Dissemination strategy.pdf';
import d2_2
    from '../assets/project.deliverables/Levitate D2.2 Project leaflet.pdf';
import d2_3
    from '../assets/project.deliverables/Levitate D2.3 Levitate Initial exploitation plan.pdf';
import d2_4
    from '../assets/project.deliverables/Levitate D2.4 Intermediate exploitation plan.pdf';
import d2_5
    from '../assets/project.deliverables/Levitate D2.5 Intermediate report on innovation business model development.pdf';
import d2_6
    from '../assets/project.deliverables/Levitate D2.6 Policy Support Tool user guide.pdf';
import d2_7
    from '../assets/project.deliverables/Levitate D2.7 Policy Recommendations Brochure.pdf';
import d3_1
    from '../assets/project.deliverables/Levitate D3.1 A taxonomy of potential impacts.pdf';
import d3_2
    from '../assets/project.deliverables/Levitate D3.2 Methods for forecasting the impacts of connected and automated vehicles.pdf';
import d3_3
    from '../assets/project.deliverables/Levitate D3.3 Converting impacts of CAVs to monetary terms.pdf';
import d3_4
    from '../assets/project.deliverables/Levitate D3.4 Methods for cost-benefit analysis to support decision making.pdf';
import d4_1
    from '../assets/project.deliverables/Levitate D4.1 Definition of Quantified Policy Goals.pdf';
import d4_2
    from '../assets/project.deliverables/Levitate D4.2 Definition of Desirable Scenarios.pdf';
import d4_3
    from '../assets/project.deliverables/Levitate D4.3 Feasible paths of interventions.pdf';
import d4_4
    from '../assets/project.deliverables/Levitate D4.4 Detailed list of forecast scenarios, applicable forecasting methodologies and necessary output variables.pdf';
import d5_1
    from '../assets/project.deliverables/Levitate D5.1 Defining the future of urban transport.pdf';
import d5_2
    from '../assets/project.deliverables/Levitate D5.2 Short term impacts of CCAM in urban transport.pdf';
import d5_3
    from '../assets/project.deliverables/Levitate D5.3 Medium term impacts of CCAM in urban transport.pdf';
import d5_4
    from '../assets/project.deliverables/Levitate D5.4 Long term impacts of CCAM in urban transport.pdf';
import d5_5
    from '../assets/project.deliverables/Levitate D5.5 Guidelines and recommendations for future policy of cooperative and automated urban transport.pdf';
import d6_1
    from '../assets/project.deliverables/Levitate D6.1 Defining the future of passenger car transport.pdf';
import d6_2
    from '../assets/project.deliverables/Levitate D6.2 Short-term Impacts of CCAM on Passenger Transport.pdf';
import d6_3
    from '../assets/project.deliverables/Levitate D6.3 Medium term impacts of CCAM on passenger transport.pdf';
import d6_4
    from '../assets/project.deliverables/Levitate D6.4 Long-term Impacts of CCAM on Passenger Transport.pdf';
import d6_5
    from '../assets/project.deliverables/Levitate D6.5 Guidelines and recommendations for future policy of cooperatve and automated passenger transport.pdf';
import d7_1
    from '../assets/project.deliverables/Levitate D7.1 Defining the future of freight transport.pdf';
import d7_2
    from '../assets/project.deliverables/Levitate D7.2 Short term impacts of CCAM on freight transport.pdf';
import d7_3
    from '../assets/project.deliverables/Levitate D7.3 Medium term impacts of CCAM on freight transport.pdf';
import d7_4
    from '../assets/project.deliverables/Levitate D7.4 Long term impacts of CCAM on freight transport.pdf';
import d7_5
    from '../assets/project.deliverables/Levitate D7.5 Guidelines and recommendations for future policy of cooperative and automated freight transport.pdf';
import d8_1
    from '../assets/project.deliverables/Levitate D8.1 Integration of outputs of WP4-7.pdf';
import d8_2
    from '../assets/project.deliverables/Levitate D8.2 Levitate -Development of a decision support tool for the assessment of the impacts of CATS.pdf';
import d8_3
    from '../assets/project.deliverables/Levitate D8.3 Application of the Decision Support Tool on Selected Use Cases.pdf';
import d8_4
    from '../assets/project.deliverables/Levitate D8.4 Policy Recommendations.pdf';
import final_technical_report
    from '../assets/project.deliverables/Levitate Final Technical Report.pdf';
import {Link} from 'react-router-dom'

function Knowledge() {

    const userDocumentationLinkTo = {
        pathname: "/knowledge_documentation",
        header: 'User Documentation'
    };

    const projectDeliverablesLinkTo = {
        pathname: "/project_deliverables",
        header: 'Project Deliverables',
        redirectToHome: true,
        files: [{name: 'Final Technical Report', path: final_technical_report},
            {name: 'D2.1 Dissemination strategy', path: d2_1},
            {name: 'D2.2: Project leaflet', path: d2_2},
            {name: 'D2.3: Levitate Initial exploitation plan', path: d2_3},
            {name: 'D2.4: Intermediate exploitation plan', path: d2_4},
            {name: 'D2.5: Intermediate report on innovation business model development', path: d2_5},
            {name: 'D2.6: Policy Support Tool user guide', path: d2_6},
            {name: 'D2.7: Policy Recommendations Brochure', path: d2_7},
            {
                name: 'D3.1: A taxonomy of potential impacts',
                description: 'This deliverable presents a taxonomy of potential impacts of Cooperative, Connected and Automated Mobility (CCAM) at different levels of implementation.',
                path: d3_1
            },
            {
                name: 'D3.2: Methods for forecasting the impacts of connected and automated vehicles',
                description: 'This deliverable presents the methods for forecasting the impacts of Cooperative, Connected and Automated Mobility (CCAM).',
                path: d3_2
            },
            {
                name: 'D3.3: Converting impacts of CAVs to monetary terms',
                description: 'This deliverable provides monetary valuations of potential impacts of connected and automated vehicles.',
                path: d3_3
            },
            {
                name: 'D3.4: Methods for cost-benefit analysis to support decision making',
                description: 'This deliverable provides documentation for the LEVITATE cost-benefit analysis (CBA) module, which is integrated in the online Policy Support Tool (PST).',
                path: d3_4
            },
            {
                name: 'D4.1: Definition of quantified policy goals',
                description: 'This deliverable describes the process and results of defining quantified policy goals within the LEVITATE project.',
                path: d4_1
            },
            {
                name: 'D4.2: Definition of desirable scenarios',
                description: 'This deliverable identifies the desirable visions, based on the quantified policy goals and the corresponding indicator framework developed within the LEVITATE project.',
                path: d4_2
            },
            {
                name: 'D4.3: Feasible paths of interventions',
                description: 'This deliverable provides preliminary answers to one of the central questions of the LEVITATE project “Given a certain vision, a set of quantified policy goals for a city or a region, how can this be connected to recommended policy interventions, supporting to achieve that vision?”.',
                path: d4_3
            },
            {
                name: 'D4.4: Detailed list of forecast scenarios, applicable methodologies and necessary output variables',
                description: 'This deliverable summarizes the temporal implementation of different sub-use cases and the forecasting methodologies that need to be employed to assess the impacts of CCAM.',
                path: d4_4
            },
            {
                name: 'D5.1: Defining the future of urban transport',
                description: ': This deliverable provides a framework under which the future of automated urban transport and resulting impacts can be defined as relevant for the future work of the LEVITATE project.',
                path: d5_1
            },
            {
                name: 'D5.2: Short-term impacts of CCAM impacts in urban transport',
                description: 'This deliverable provides an analysis for the short-term impacts of different automated urban transport sub-use cases.',
                path: d5_2
            },
            {
                name: 'D5.3: Medium-term impacts of CCAM impacts in urban transport',
                description: 'This deliverable provides an analysis for the medium-term impacts of different automated urban transport sub-use cases.',
                path: d5_3
            },
            {
                name: 'D5.4: Long-term impacts of CCAM impacts in urban transport',
                description: 'This deliverable provides an analysis for the long-term impacts of different automated urban transport sub-use cases.',
                path: d5_4
            },
            {
                name: 'D5.5: Guidelines and recommendations for future policy of cooperative and automated urban transport',
                description: 'This deliverable summarizes the more detailed results presented in D5.2-D5.4 in order to provide an overview of the main expected trends for each impact of CCAM in urban transport.',
                path: d5_5
            },
            {
                name: 'D6.1: Defining the future of passenger car transport',
                description: 'This deliverable provides a framework under which the future of automated passenger car transport and resulting impacts can be defined as relevant for the future work of the LEVITATE project.',
                path: d6_1
            },
            {
                name: 'D6.2: Short-term impacts of CCAM impacts on passenger transport',
                description: 'This deliverable provides an analysis for the short-term impacts of different automated passenger transport sub-use cases.',
                path: d6_2
            },
            {
                name: 'D6.3: Medium-term impacts of CCAM impacts on passenger transport',
                description: 'This deliverable provides an analysis for the medium-term impacts of different automated passenger transport sub-use cases.',
                path: d6_3
            },
            {
                name: 'D6.4: Long-term impacts of CCAM impacts on passenger transport',
                description: 'This deliverable provides an analysis for the long-term impacts of different automated passenger transport sub-use cases.',
                path: d6_4
            },
            {
                name: 'D6.5: Guidelines and recommendations for future policy of cooperative and automated passenger transport',
                description: 'This deliverable summarizes the more detailed results presented in D6.2-D6.4 in order to provide an overview of the main expected trends for each impact of CCAM in passenger transport.',
                path: d6_5
            },
            {
                name: 'D7.1: Defining the future of freight transport',
                description: 'This deliverable provides a framework under which the future of automated freight transport and resulting impacts can be defined as relevant for the future work of the LEVITATE project.',
                path: d7_1
            },
            {
                name: 'D7.2: Short-term impacts of CCAM impacts on freight transport',
                description: 'This deliverable provides an analysis for the short-term impacts of different automated freight transport sub-use cases.',
                path: d7_2
            },
            {
                name: 'D7.3: Medium-term impacts of CCAM impacts on freight transport',
                description: 'This deliverable provides an analysis for the medium-term impacts of different automated freight transport sub-use cases.',
                path: d7_3
            },
            {
                name: 'D7.4: Long-term impacts of CCAM impacts on freight transport',
                description: 'This deliverable provides an analysis for the long-term impacts of different automated freight transport sub-use cases.',
                path: d7_4
            },
            {
                name: 'D7.5: Guidelines and recommendations for future policy of cooperative and automated freight transport',
                description: 'This deliverable summarizes the more detailed results presented in D7.2-D7.4 in order to provide an overview of the main expected trends for each impact of CCAM in freight transport.',
                path: d7_5
            },
            {
                name: 'D8.1: Integration of outputs of WP4-7',
                description: 'This deliverable focuses on the integration of outputs from Work Packages (WPs) 4 to 7, in order to create the LEVITATE PST.',
                path: d8_1
            },
            {
                name: 'D8.2: Development of a policy support tool for the assessment of the impacts of CCAM',
                description: 'This deliverable presents the creation and development of the online PST based on the data provided by D8.1.',
                path: d8_2
            },
            {
                name: 'D8.3: Application of the decision support tool on selected use cases',
                description: 'This deliverable presents the application of the Levitate methodologies and PST on selected case studies and the corresponding results.',
                path: d8_3
            },
            {
                name: 'D8.4: Policy Recommendations for Connected, Cooperative, and Automated Mobility',
                description: 'This deliverable presents the overall lessons based on knowledge gathered within Levitate and condensed into broadly applicable CCAM policy recommendations',
                path: d8_4
            }
        ]

    }

    return (
        <Container className="container knowledge">
            <Row className="pb-4 pt-4">
                <h3>Knowledge module</h3>
            </Row>
            <Row className="mt-4 mb-2 pt-2 pb-4">
                <Col className="text-center col-6">
                    <div className="card">
                        <Link to={userDocumentationLinkTo}>
                            <img src={UserDocumentationImage} className="card-img-top"/>
                            <div className="card-body">
                                <h5 className="card-title">User Documentation</h5>
                            </div>
                        </Link>
                    </div>
                </Col>
                <Col className="text-center col-6">
                    <div className="card">
                        <Link to={projectDeliverablesLinkTo}>
                            <img src={ProjectDeliveralblesImage} className="card-img-top"/>
                            <div className="card-body">
                                <h5 className="card-title">Project Deliverables</h5>
                            </div>
                        </Link>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default Knowledge;
